import { mapGetters } from 'vuex'

export default {
    props: {
        course: Object,
        isUncompletedItem: {
            type: Boolean,
            default: false
        },
        isCompletedItem: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            isLive: 'Courses/isLive',
            mapCourseToRibbon: 'Courses/mapCourseToRibbon',
            mapCourseToTimeBasedRibbon: 'Courses/mapCourseToTimeBasedRibbon',
            showAuthorizationId: 'Courses/shouldShowAuthorizationId',
            isLoggedIn: 'isLoggedIn',
            isCourseCompleted: 'CompletedCourses/isCourseCompleted',
            isDigitalClassRoomTraining: 'Courses/isDigitalClassRoomTraining'
        }),
        isCompleted () {
            if (this.course.courseId) {
                return this.isCourseCompleted(this.course.courseId)
            }
            return this.isCourseCompleted(this.course.id)
        },
        isFree () {
            return this.course.free
        },
        isPromotional () {
            return this.course.promotional && !this.course.free
        },
        showSignUpToDigitalClassRoomInfo () {
            return this.isDigitalClassRoomTraining(this.course) && this.isLoggedIn && !this.course.demo && !this.isCourseCompleted(this.course.id)
        },
        showTags () {
            return this.mapCourseToRibbon(this.course) ||
                this.mapCourseToTimeBasedRibbon(this.course) ||
                this.showAuthorizationId(this.course) ||
                this.showSignUpToDigitalClassRoomInfo ||
                this.isCompleted ||
                this.isUncompletedItem ||
                this.isFree ||
                this.isPromotional
        }
    }
}
